<template>
  <DsShowcase title="SelectPlayV2" description="Select dropdown com busca, tamanhos e estados. Usa trackBy/label para mapear objetos.">
    <!-- PROP: options + modelValue -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">options / v-model</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>options: Array&lt;{ id, label, ... }&gt;</code> — <code>trackBy</code> define o campo de valor, <code>label</code> define o campo de texto</p>
      <div class="tw:max-w-lg tw:space-y-4">
        <SelectPlayV2 v-model="val1" :options="countries" placeholder="Selecione um país" />
        <p class="tw:text-xs tw:opacity-50">Valor: {{ val1 ?? 'null' }}</p>
      </div>
    </section>

    <!-- PROP: size -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">size</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>'sm' | 'md' | 'lg'</code></p>
      <div class="tw:max-w-lg tw:space-y-4">
        <SelectPlayV2 v-model="val2" :options="categories" size="sm" placeholder="Small" />
        <SelectPlayV2 v-model="val3" :options="categories" size="md" placeholder="Medium" />
        <SelectPlayV2 v-model="val4" :options="categories" size="lg" placeholder="Large" />
      </div>
    </section>

    <!-- PROP: searchable -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">searchable</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code> — exibe campo de busca dentro do dropdown</p>
      <div class="tw:max-w-lg">
        <SelectPlayV2 v-model="val5" :options="countries" :searchable="true" placeholder="Busque por nome..." />
      </div>
    </section>

    <!-- PROP: error -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">error</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code> — borda de erro</p>
      <div class="tw:max-w-lg">
        <SelectPlayV2 v-model="val6" :options="categories" :error="true" placeholder="Campo obrigatório" />
      </div>
    </section>

    <!-- PROP: disabled / skeleton -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">disabled / skeleton</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code></p>
      <div class="tw:max-w-lg tw:space-y-4">
        <SelectPlayV2 :options="categories" model-value="marketing" :disabled="true" />
        <SelectPlayV2 :options="categories" :skeleton="true" />
      </div>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import DsShowcase from '../DsShowcase.vue'
import { SelectPlayV2 } from "@/components/atomic"

const val1 = ref(null)
const val2 = ref(null)
const val3 = ref(null)
const val4 = ref(null)
const val5 = ref(null)
const val6 = ref(null)

const countries = [
  { id: 'br', label: 'Brasil' },
  { id: 'pt', label: 'Portugal' },
  { id: 'us', label: 'Estados Unidos' },
  { id: 'fr', label: 'França' },
  { id: 'de', label: 'Alemanha' },
  { id: 'jp', label: 'Japão' },
  { id: 'ar', label: 'Argentina' },
]

const categories = [
  { id: 'marketing', label: 'Marketing' },
  { id: 'vendas', label: 'Vendas' },
  { id: 'tech', label: 'Tecnologia' },
  { id: 'design', label: 'Design' },
]
</script>
